import { formatPersianDateTime } from "@/shared/lib";

import type { DateTimeValue } from "../../lib/date-time";

type PersianDateTimeProps = {
  value: DateTimeValue;
};

export default function PersianDateTime({ value }: PersianDateTimeProps) {
  return <bdi dir="ltr">{formatPersianDateTime(value)}</bdi>;
}
